class SearchableSelect {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.select = wrapper.querySelector('select.select__select');
    if (!this.select || wrapper.dataset.searchableSelectInit) return;
    wrapper.dataset.searchableSelectInit = 'true';

    this.build();
    this.bindEvents();
  }

  build() {
    const options = Array.from(this.select.options);

    this.trigger = document.createElement('button');
    this.trigger.type = 'button';
    this.trigger.className = 'searchable-select__trigger';
    this.trigger.setAttribute('aria-haspopup', 'listbox');
    this.trigger.setAttribute('aria-expanded', 'false');

    this.panel = document.createElement('div');
    this.panel.className = 'searchable-select__panel';
    this.panel.hidden = true;

    const searchWrapper = document.createElement('div');
    searchWrapper.className = 'searchable-select__search-wrapper';

    this.searchInput = document.createElement('input');
    this.searchInput.type = 'text';
    this.searchInput.className = 'searchable-select__search';
    this.searchInput.setAttribute('placeholder', 'Search');
    this.searchInput.setAttribute('aria-label', 'Search options');
    this.searchInput.setAttribute('autocomplete', 'off');
    searchWrapper.appendChild(this.searchInput);

    this.optionsList = document.createElement('ul');
    this.optionsList.className = 'searchable-select__options';
    this.optionsList.setAttribute('role', 'listbox');

    this.noResults = document.createElement('li');
    this.noResults.className = 'searchable-select__no-results';
    this.noResults.textContent = 'No matches found';
    this.noResults.hidden = true;

    options.forEach((option) => {
      const li = document.createElement('li');
      li.setAttribute('role', 'presentation');

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'searchable-select__option';
      button.setAttribute('role', 'option');
      button.dataset.value = option.value;
      button.textContent = option.textContent.trim();
      if (option.selected) {
        button.setAttribute('aria-selected', 'true');
      }

      li.appendChild(button);
      this.optionsList.appendChild(li);
    });

    this.panel.appendChild(searchWrapper);
    this.panel.appendChild(this.optionsList);
    this.optionsList.appendChild(this.noResults);

    this.wrapper.insertBefore(this.trigger, this.select);
    this.wrapper.appendChild(this.panel);

    this.updateTriggerLabel();
  }

  updateTriggerLabel() {
    const selectedOption = this.select.options[this.select.selectedIndex];
    this.trigger.textContent = selectedOption ? selectedOption.textContent.trim() : '';
  }

  bindEvents() {
    this.trigger.addEventListener('click', () => {
      if (this.panel.hidden) {
        this.open();
      } else {
        this.close();
      }
    });

    this.searchInput.addEventListener('input', () => this.filter());

    this.optionsList.addEventListener('click', (event) => {
      const optionButton = event.target.closest('.searchable-select__option');
      if (!optionButton) return;
      this.selectValue(optionButton.dataset.value);
    });

    this.panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        this.close();
        this.trigger.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (this.panel.hidden) return;
      if (this.wrapper.contains(event.target)) return;
      this.close();
    });
  }

  open() {
    this.panel.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.searchInput.value = '';
    this.filter();
    this.searchInput.focus();
  }

  close() {
    this.panel.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  filter() {
    const query = this.searchInput.value.trim().toLowerCase();
    let visibleCount = 0;

    this.optionsList.querySelectorAll('.searchable-select__option').forEach((optionButton) => {
      const matches = optionButton.textContent.toLowerCase().includes(query);
      optionButton.parentElement.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    this.noResults.hidden = visibleCount !== 0;
  }

  selectValue(value) {
    this.select.value = value;
    this.select.dispatchEvent(new Event('change', { bubbles: true }));

    this.optionsList.querySelectorAll('.searchable-select__option').forEach((optionButton) => {
      if (optionButton.dataset.value === value) {
        optionButton.setAttribute('aria-selected', 'true');
      } else {
        optionButton.removeAttribute('aria-selected');
      }
    });

    this.updateTriggerLabel();
    this.close();
    this.trigger.focus();
  }
}

function initSearchableSelects(root = document) {
  root.querySelectorAll('.js-searchable-select').forEach((wrapper) => {
    new SearchableSelect(wrapper);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initSearchableSelects();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => initSearchableSelects());
  }
});
document.addEventListener('shopify:section:load', (event) => initSearchableSelects(event.target));
